
import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import NotFound from "./pages/NotFound";
import { ResourcesProvider } from "./contexts/ResourcesContextProvider";
import CategoryPage from "./pages/CategoryPage";
import ResourceDetailsPage from "./pages/ResourceDetailsPage";
import AddResourcePage from "./pages/AddResourcePage";
import AddCategoryPage from "./pages/AddCategoryPage";
import { useState } from "react";

// Set up a query client with more reasonable cache settings
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 5, // 5 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes
    },
  },
});

const App = () => {
  const [refreshKey] = useState<number>(Date.now());

  return (
    <QueryClientProvider client={queryClient}>
      <ResourcesProvider>
        <TooltipProvider>
          <Toaster />
          <Sonner />
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Index key={`index-${refreshKey}`} />} />
              <Route path="/category/:categoryId" element={<CategoryPage key={`category-${refreshKey}`} />} />
              <Route path="/resource/:resourceId" element={<ResourceDetailsPage key={`resource-details-${refreshKey}`} />} />
              <Route path="/add-resource" element={<AddResourcePage key={`add-resource-${refreshKey}`} />} />
              <Route path="/add-category" element={<AddCategoryPage key={`add-category-${refreshKey}`} />} />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
        </TooltipProvider>
      </ResourcesProvider>
    </QueryClientProvider>
  );
};

export default App;
